
export const PLATFORMS = {
  PRESTASHOP: "PRESTASHOP",
  SHOPIFY: "SHOPIFY"
}